import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";

import Lab from "./screens/Lab";
import Cart from "./screens/Cart";

import Product from "./screens/Product";
import ShareEmotion from "./screens/ShareEmotion";
import Policy from "./screens/Policy";
import Test from "./screens/Test"; // TEST
import Privacy from "./screens/Privacy";
import PrivacyAndroid from "./screens/PrivacyAndroid";
import PrivacyIos from "./screens/PrivacyIos";
import Terms from "./screens/AppService";
import AppPage from "./screens/AppPage";
import WebTicket from "./screens/WebTicket";
import IDCard from "./screens/IDCard";
import InsideTicket from "./screens/InsideTicket";
import NodelTicket from "./screens/NodelTicket";
import Hapjeong2025Ticket from "./screens/Hapjeong2025Ticket";
import SVTTicket from "./screens/SVTTicket";
import AskStar from "./screens/AskStar";
import DivorceInsurance from "./screens/DivorceInsurance";
import YGWebTicket from "./screens/YGWebTicket";
import RandomDiversity2026Ticket from "./screens/RandomDiversity2026Ticket";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Lab />} />
      <Route path="/lab" element={<Lab />} />
      <Route path="/lab/:product" element={<Product />} />
      <Route path="/cart" element={<Cart />} />
      <Route path="/share-emotion" element={<ShareEmotion />} />
      <Route path="/policy" element={<Policy />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/privacy/android" element={<PrivacyAndroid />} />
      <Route path="/privacy/ios" element={<PrivacyIos />} />
      <Route path="/app/service" element={<Terms />} />
      <Route path="/app" element={<AppPage />} />
      <Route path="/rd-ticket" element={<WebTicket />} />
      <Route path="/yg-2025" element={<YGWebTicket />} />
      <Route path="/rd-2024" element={<NodelTicket />} />
      <Route path="/rd-2025-frag" element={<Hapjeong2025Ticket />} />
      <Route
        path="/rd-2026-color"
        element={
          <RandomDiversity2026Ticket
            experience="color"
            expectedTicketType="7"
          />
        }
      />
      <Route
        path="/rd-2026-fragrance"
        element={
          <RandomDiversity2026Ticket
            experience="fragrance"
            expectedTicketType="8"
          />
        }
      />
      <Route path="/id-card" element={<IDCard />} />
      <Route path="/inside-ticket" element={<InsideTicket />} />
      <Route path="/svt-ticket" element={<SVTTicket />} />
      <Route path="/ask-star" element={<AskStar />} />
      <Route path="/divorce-insurance" element={<DivorceInsurance />} />
      {/* <Route path='/test' element={<Test />} /> */}
    </Routes>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
